import * as types from '../mutation-types'
import mutation from '../mutation'
import * as HelpService from '@/service/HelpService'

const state = {
	questions: [],
	searchQuestions: [],
	userQuestions: [],
	pageNo: 1,
	pageSize: 20,
	questionsDetail: {},
}
const getters = {
	questions: () => state.questions,
	searchQuestions: () => state.searchQuestions,
	userQuestions: () => state.userQuestions,
	questionsDetail: () => state.questionsDetail,
	pageNo: () => state.pageNo,
}
const mutations = {
	[types.GET_ARTICLE_LIST](state, data) {
		state.pageNo = state.pageNo + 1
		state.questions = [...state.questions, ...data]
	},
	[types.SEARCH_ARTICLE_LIST](state, data) {
		state.searchQuestions = data
	},
	[types.USER_ARTICLE_LIST](state, data) {
		state.pageNo = state.pageNo + 1
		state.userQuestions = [...state.userQuestions, ...data]
	},
	[types.GET_ARTICLE_DETAIL](state, data) {
		state.questionsDetail = data
	},
	[types.GET_ARTICLE_MARK](state, {data, markType, act}){
		if (markType === 'like') {
			if (act){
				state.questionsDetail.hate = !act
			}
			state.questionsDetail.like = act
		} else {
			if (act){
				state.questionsDetail.like = !act
			}
			state.questionsDetail.hate = act
		}
		state.questionsDetail.hateCount = data.hateCount
		state.questionsDetail.likeCount = data.likeCount
	},
	[types.INIT_ARTICLE_LIST](state, data) {
		state.questions = data.questions
		state.pageNo = data.pageNo
	},
	[types.INIT_USER_ARTICLE](state, data) {
		state.userQuestions = data.userQuestions
		state.pageNo = data.pageNo
	},
	[types.INIT_ARTICLE_DETAIL](state, data) {
		state.questionsDetail = []
	},
	[types.INIT_SEARCH_LIST](state, data) {
		state.searchQuestions = []
	},
	...mutation
}
const actions = {
	getArticleList({ commit, state }, { pageNo, searchKey, categoryId, categoryName,pageSize }) {
		return HelpService.getArticleList(pageNo, searchKey, categoryId, categoryName,pageSize).then(
			res => {
				if (categoryName === "常见问题" && searchKey) {
					commit(types.SEARCH_ARTICLE_LIST, res.data.data);
				} else if (categoryName === "常见问题") {
					commit(types.GET_ARTICLE_LIST, res.data.data);
				} else if (categoryName === "用户手册") {
					commit(types.USER_ARTICLE_LIST, res.data.data);
				}
				return Promise.resolve(res);
			},
			rea => {
				return Promise.reject(rea);
			}
		);
	},
	initArticleList({ commit, state }, data) {
		commit(types.INIT_ARTICLE_LIST, data);
	},
	initUserArticleList({ commit, state }, data) {
		commit(types.INIT_USER_ARTICLE, data);
	},

	getArticleDetail({ commit, state }, { articleId }) {
		return HelpService.getArticleDetail(articleId).then(
			res => {
				commit(types.GET_ARTICLE_DETAIL, res.data);
				return Promise.resolve(res);
			},
			rea => {
				return Promise.reject(rea);
			}
		);
	},
	initArticleDetail({ commit, state }, data) {
		commit(types.INIT_ARTICLE_DETAIL, data);
	},
	initSearchList({ commit, state }, data) {
		commit(types.INIT_SEARCH_LIST, data);
	},
	getArticleMark({ commit, state }, { articleId, markType, act }) {
		return HelpService.getArticleMark(articleId, markType, act).then(
			res => {
				commit(types.GET_ARTICLE_MARK, { data: res.data, markType, act });
				return Promise.resolve(res);
			},
			rea => {
				return Promise.reject(rea);
			}
		);
	},
};
export default {
	state,
	getters,
	actions,
	mutations
}
